import gql from 'graphql-tag'

export const ALL_USERS = gql`
  query {
    allUsers(order: "name", where: { status: "live" }) {
      id
      name
      email
      profile
      role
      lastLoginAt
      createdAt
    }
  }
`
